document.addEventListener('DOMContentLoaded', function() {
    var blogLayoutJsSorter = document.getElementById('blog-layout-js-sorter');

    var items = Array.prototype.slice.call(blogLayoutJsSorter.children, 0);
    items.sort(function(a, b) {
        var date1 = new Date(a.querySelector('.blog-item__meta .blog-item__date').textContent);
        var date2 = new Date(b.querySelector('.blog-item__meta .blog-item__date').textContent);
        return date2 - date1;
    });

    items.forEach(function(item) {
        blogLayoutJsSorter.appendChild(item);
    });

    blogLayoutJsSorter.classList.remove('hidden');
});